export default "__VITE_ASSET__053ea072__"